import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Inventory } from '@app/_models/_DTOs/inventory';
import { ITuple } from '@app/_models/tuple';
import { InventoryAsset } from '@app/_models/_DTOs/inventoryAsset';
import { InventoryCompletion } from '@app/_models/inventoryCompletion';
import { UserInventoryCompletion } from '@app/_models/userInventoryCompletion';
import { InventoryAssetsByBarCodeResponse } from '@app/_models/_response/inventoryAssetsByBarCode.response';
import { InventoryViewModel } from '@app/_models/_viewModels/inventory.viewmodel';
import { TotalInventoryCompletion } from '@app/_models/totalInventoryCompletion';
import { AssetType } from '@app/_models/enums/assetType';
import { ReportFileType } from '@app/_models/enums/reportFileType';
import { RemoveDiscardProposalViewModel } from '@app/_models/_viewModels/removeDiscardProposal.viewmodel';

@Injectable({ providedIn: 'root' })
export class InventoryService extends DataService<Inventory> {
    constructor(http: HttpClient) {
        super(http, "api/inventory")
    }

    create(viewModel: InventoryViewModel) {
        return this.http.post(`${environment.apiUrl}/${this.endpoint}/AddInventory`, viewModel, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    edit(viewModel: InventoryViewModel, inventoryId: number) {
        return this.http.put(`${environment.apiUrl}/${this.endpoint}/EditInventory/${inventoryId}`, viewModel, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    getAssetCount(viewModel: InventoryViewModel) {
        return this.http.post(`${environment.apiUrl}/${this.endpoint}/GetInventoryAssetCount`, viewModel, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    getExistingAssetCount(inventoryId: number) {
        return this.http.get<number>(`${environment.apiUrl}/${this.endpoint}/GetExistingInventoryAssetCount/${inventoryId}`);
    }

    getInventoriesInProgress() {
        return this.http.get<Inventory[]>(`${environment.apiUrl}/${this.endpoint}/inprogress/`);
    }

    searchInventoryAssets(inventoryId: number, barCode: string) {
        return this.http.get<InventoryAssetsByBarCodeResponse>(`${environment.apiUrl}/${this.endpoint}/${inventoryId}/assets/${barCode}`);
    }

    getCompletionForUser(id: number) {
        return this.http.get<InventoryCompletion>(`${environment.apiUrl}/${this.endpoint}/GetInventoryCompletionForUser/${id}`);
    }

    getCompletion(id: number) {
        return this.http.get<UserInventoryCompletion[]>(`${environment.apiUrl}/${this.endpoint}/GetInventoryCompletion/${id}`);
    }

    getTotalCompletion(id: number) {
        return this.http.get<TotalInventoryCompletion>(`${environment.apiUrl}/${this.endpoint}/GetTotalInventoryCompletion/${id}`);
    }

    getReport(inventoryId: number, assetType: AssetType, reportFileType: ReportFileType) {
        return this.http.get(`${environment.apiUrl}/${this.endpoint}/GetReport/${inventoryId}/${assetType}/${reportFileType}`, { responseType: "blob" });
    }

    removeAssetDiscardProposal(viewModel: RemoveDiscardProposalViewModel) {
        return this.http.post(`${environment.apiUrl}/${this.endpoint}/RemoveAssetDiscardProposal`, viewModel, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }
}